import type { ApiError } from "../../../api/client";

/**
 * Greške sa tačaka za kontrauzorke, na jeziku korisnika.
 *
 * Server vraća oznaku greške (`code`) i tekst na engleskom, jer oznaka je ono što ne zavisi od jezika.
 * Prevod stoji ovde, uz ekran koji grešku i prikazuje. Nepoznata oznaka pada na serverov tekst — bolje
 * engleska rečenica koja nešto kaže nego prazna poruka.
 */
const PORUKE: Record<string, [string, string]> = {
  EXACTLY_ONE_LINK: [
    "retained.err.exactlyOneLink",
    "Uzorak se vezuje za tačno jedno: isporuku, prijemnu šaržu ili LOT gotove robe.",
  ],
  KEEP_UNTIL_BEFORE_TAKEN: [
    "retained.err.keepUntilBeforeTaken",
    "Rok čuvanja ne može da se završi pre dana kada je uzorak uzet.",
  ],
  KEEP_UNTIL_CONTRADICTION: [
    "retained.err.keepUntilContradiction",
    "Rok se u istom upisu ne može i postaviti i skinuti.",
  ],
  DELIVERY_NOT_FOUND: ["retained.err.deliveryNotFound", "Ta isporuka ne postoji."],
  RECEIVING_LOT_NOT_FOUND: ["retained.err.receivingLotNotFound", "Ta prijemna šarža ne postoji."],
  NOT_FOUND: ["retained.err.notFound", "Uzorak ne postoji ili je već sklonjen sa spiska."],
  FORBIDDEN: ["retained.err.forbidden", "Za ovu radnju nemate pravo."],
};

/**
 * Ključ prevoda i podrazumevani tekst za poznatu oznaku, ili `null` za nepoznatu.
 *
 * `null` namerno, a ne opšti ključ: opšti ključ bi, kad ga neko jednom prevede, pokrio i greške koje
 * server objašnjava svojim tekstom, i to objašnjenje bi se izgubilo.
 */
export function retainedErrorMessage(e: ApiError): [string, string] | null {
  return PORUKE[e.code] ?? null;
}
